import { useMemo } from 'react'
import { useGetConfigQuery, useListFactorsQuery } from '../../store/mfa/mfa'
import { type Token } from '../../common/token'
import { type AuthenticatedUser } from '../../models/User'
import { isMFAFactorTypeCompliant } from './mfaCompliance'

export type MFAComplianceStatus = 'pending' | 'compliant' | 'nonCompliant'

export const useMFAComplianceCheck = (user: AuthenticatedUser | null, token: Token | null): MFAComplianceStatus => {
  const isFullAuthToken = !!token && token.tokenUse === 'access'

  const { data: config } = useGetConfigQuery(user?.accountId ?? '', { skip: !user || !isFullAuthToken })
  const { data: factors } = useListFactorsQuery({ accountId: user?.accountId ?? '' }, { skip: !user || !isFullAuthToken })

  return useMemo<MFAComplianceStatus>(() => {
    if (!isFullAuthToken) return 'pending'
    if (!config || !factors) return 'pending'
    return isMFAFactorTypeCompliant(config, factors) ? 'compliant' : 'nonCompliant'
  }, [isFullAuthToken, config, factors])
}
